import { Mesh } from "../Mesh/Mesh";
import { RenderObject } from "./RenderObject";
import { RenderMode } from "./ObjectManager";
import { Scene } from "../Scene";

export class RenderObjectFactory {

    constructor(private scene: Scene) {
    }

    public instantiateMesh(mesh: Mesh, modes: RenderMode[]): RenderObject {
        let obj = mesh.createInstance(this.scene.ctx);
        this.scene.objectManager.addObject(obj, ...modes);
        return obj;
    }

    public create(objectType: string, modes: RenderMode[]): RenderObject {
        let mesh = this.scene.meshManager.getMesh(objectType);
        return this.instantiateMesh(mesh, modes);
    }
}

